import config from "@/config";
import http from "@/utils/request";

// 权限管理：角色（迁移自 managesaas sass.js 的角色系列接口，URL 与旧租户后台一致）
export default {
	index: {
		url: `${config.API_URL}/manage/member.Role/index`,
		name: "角色列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	setRoleStatus: {
		url: `${config.API_URL}/manage/member.Role/setStatus`,
		name: "更改角色组状态",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	roleDelete: {
		url: `${config.API_URL}/manage/member.Role/delete`,
		name: "删除角色组",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	getRoleTree: {
		url: `${config.API_URL}/manage/member.Role/getRoleTree`,
		name: "拥有角色列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	getNodeTree: {
		url: `${config.API_URL}/manage/member.Role/getNodeTree`,
		name: "角色权限列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	roleAdd: {
		url: `${config.API_URL}/manage/member.Role/add`,
		name: "添加角色组",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	roleEdit: {
		url: `${config.API_URL}/manage/member.Role/edit`,
		name: "编辑角色组",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
};
